import { em, px } from "csx";
import { FC, ReactElement } from "react";
import { classes, style, stylesheet } from "typestyle";
import { Colours, Sizes, fontFamily } from "../../styles";

interface Props {
  label?: string | ReactElement;
  isRequired?: boolean;
  size?: "sm" | "md";
  htmlFor?: string;
}

export const InputLabel: FC<Props> = ({
  label,
  isRequired,
  size,
  htmlFor,
}): ReactElement => {
  return (
    <>
      {label && (
        <label
          htmlFor={htmlFor}
          className={classes(
            classNames.label,
            style({
              fontSize: size === "md" ? px(16) : undefined,
              lineHeight: size === "md" ? px(17) : undefined,
            }),
          )}
        >
          {label}
          {isRequired && "*"}
        </label>
      )}
    </>
  );
};

const classNames = stylesheet({
  label: {
    color: Colours.textLight,
    fontSize: Sizes.fontSize1,
    fontFamily,
    height: em(1),
  },
});
